/* =========================================================================
   SAMSARA — PAGE-FAQ.JS
   Sprint 5 / T6 — FAQ accordion radio behavior (auto-close on open).

   Native <details> works no-JS. JS = enhancement: when user opens one
   <details>, all others în same category close. Reduces scrolling +
   visual noise. Keyboard + screen reader friendly (preserves native
   summary toggle behavior).

   Vanilla, ~30 lines.
   ========================================================================= */

(function () {
  'use strict';

  function init() {
    const categories = document.querySelectorAll('[data-faq-category]');
    if (!categories.length) return;

    categories.forEach(function (cat) {
      const items = cat.querySelectorAll('[data-faq-item]');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (item.open) {
            items.forEach(function (other) {
              if (other !== item && other.open) {
                other.open = false;
              }
            });
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
